import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fortawesome/fontawesome-svg-core/styles.css';
import { registerSW } from 'virtual:pwa-register';
import App from './App';
import './i18n';
import './index.css';

registerSW({ immediate: true });

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);